var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user_descriptions" }, [
    _c(
      "div",
      { staticClass: "url_settings mb-5 mt-3" },
      [
        _c("yes_no", {
          key: "BASE_URL_TYPE",
          attrs: { radio_options: _vm.base_url_options, title: "URL_TYPE" },
          on: { change: _vm.loadBaseUrl },
          model: {
            value: _vm.pwa.base_url_type,
            callback: function ($$v) {
              _vm.$set(_vm.pwa, "base_url_type", $$v)
            },
            expression: "pwa.base_url_type",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "url_info" },
          [
            _c("b-overlay", { attrs: { show: _vm.is_load_ulr } }, [
              _c("div", { staticClass: "form-group mt-5" }, [
                _c(
                  "label",
                  { staticClass: "form-label", attrs: { for: "pwa.base_url" } },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.__t("pwa.base_url")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group flex-nowrap" },
                  [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("b-form-input", {
                      staticClass: "form-control",
                      attrs: {
                        disabled: !_vm.can_edit_url,
                        id: "pwa.base_url",
                      },
                      model: {
                        value: _vm.pwa.base_url,
                        callback: function ($$v) {
                          _vm.$set(_vm.pwa, "base_url", $$v)
                        },
                        expression: "pwa.base_url",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "GEO_ON_START",
            attrs: { title: "PWA_GEO_ON_START" },
            model: {
              value: _vm.is_geo_on,
              callback: function ($$v) {
                _vm.is_geo_on = $$v
              },
              expression: "is_geo_on",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "PAY_TABLE",
            attrs: { title: "PAY_TABLE" },
            model: {
              value: _vm.pay_table,
              callback: function ($$v) {
                _vm.pay_table = $$v
              },
              expression: "pay_table",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "SMS_AUTH_STATE",
            attrs: { title: "SMS_AUTH_STATE" },
            model: {
              value: _vm.sms_auth,
              callback: function ($$v) {
                _vm.sms_auth = $$v
              },
              expression: "sms_auth",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "SHOW_CONTACT_FORM",
            attrs: { title: "SHOW_CONTACT_FORM" },
            model: {
              value: _vm.pwa.show_contact_form,
              callback: function ($$v) {
                _vm.$set(_vm.pwa, "show_contact_form", $$v)
              },
              expression: "pwa.show_contact_form",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "SHOW_CATALOG_STOP",
            attrs: { title: "SHOW_CATALOG_STOP" },
            model: {
              value: _vm.pwa.show_catalog_stop,
              callback: function ($$v) {
                _vm.$set(_vm.pwa, "show_catalog_stop", $$v)
              },
              expression: "pwa.show_catalog_stop",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "USE_ESTIMATE",
            attrs: { title: "USE_ESTIMATE" },
            model: {
              value: _vm.pwa.use_estimate,
              callback: function ($$v) {
                _vm.$set(_vm.pwa, "use_estimate", $$v)
              },
              expression: "pwa.use_estimate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "PAY_BONUS",
            attrs: { title: "PAY_BONUS" },
            model: {
              value: _vm.pay_bonus,
              callback: function ($$v) {
                _vm.pay_bonus = $$v
              },
              expression: "pay_bonus",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 col-sm-3 col-md-3 col-xs-12" },
        [
          _c("yes_no", {
            key: "ALLOW_INSTALL",
            attrs: { title: "ALLOW_INSTALL" },
            model: {
              value: _vm.allow_install,
              callback: function ($$v) {
                _vm.allow_install = $$v
              },
              expression: "allow_install",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.pay_bonus
      ? _c("div", { staticClass: "form-group mt-5" }, [
          _c(
            "label",
            {
              staticClass: "form-label",
              attrs: { for: "pwa.bonus_max_percent" },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.__t("pwa.bonus_max_percent")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group flex-nowrap" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "form-control",
                attrs: { min: "0", max: "100", id: "pwa.bonus_max_percent" },
                model: {
                  value: _vm.pwa.bonus_max_percent,
                  callback: function ($$v) {
                    _vm.$set(_vm.pwa, "bonus_max_percent", $$v)
                  },
                  expression: "pwa.bonus_max_percent",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "pwa.default_geo_radius" } },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.__t("pwa.default_geo_radius")) +
              "\n            "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "form-control",
            attrs: { id: "pwa.default_geo_radius" },
            model: {
              value: _vm.default_geo_radius,
              callback: function ($$v) {
                _vm.default_geo_radius = $$v
              },
              expression: "default_geo_radius",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        {
          staticClass: "form-label",
          attrs: { for: "pwa.default_delivery_price" },
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.__t("pwa.default_delivery_price")) +
              "\n            "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "form-control",
            attrs: { id: "pwa.default_delivery_price" },
            model: {
              value: _vm.default_delivery_price,
              callback: function ($$v) {
                _vm.default_delivery_price = $$v
              },
              expression: "default_delivery_price",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        {
          staticClass: "form-label",
          attrs: { for: "pwa.default_delivery_min_price" },
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.__t("pwa.default_delivery_min_price")) +
              "\n            "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _vm._m(3),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "form-control",
            attrs: { id: "pwa.default_delivery_min_price" },
            model: {
              value: _vm.default_delivery_min_price,
              callback: function ($$v) {
                _vm.default_delivery_min_price = $$v
              },
              expression: "default_delivery_min_price",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        {
          staticClass: "form-label",
          attrs: { for: "pwa.default_delivery_price" },
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.__t("pwa.default_delivery_time")) +
              "\n            "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _vm._m(4),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "form-control",
            attrs: { id: "pwa.default_delivery_time" },
            model: {
              value: _vm.default_delivery_time,
              callback: function ($$v) {
                _vm.default_delivery_time = $$v
              },
              expression: "default_delivery_time",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        {
          staticClass: "form-label",
          attrs: { for: "pwa.default_delivery_price" },
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.__t("pwa.phones")) +
              "\n            "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _vm._m(5),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "form-control",
            attrs: { id: "pwa.phones" },
            model: {
              value: _vm.default_phones,
              callback: function ($$v) {
                _vm.default_phones = $$v
              },
              expression: "default_phones",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group main_discount_org" }, [
      _c("div", { staticClass: "form-group mt-2" }, [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "organization" } },
          [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__t("pwa.discount_program_org")) +
                "\n                "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.organizations.length > 0
          ? _c(
              "div",
              {},
              [
                _c(
                  "v-select",
                  {
                    staticClass: "imc_reasons",
                    attrs: {
                      label: "title",
                      options: this.organizations,
                      filterable: false,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function (option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _c("div", [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(option.title) +
                                      "\n                                    "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "small badge border border-info text-info mr-1",
                                    },
                                    [_vm._v(" " + _vm._s(option.provider))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("small", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(option.uniq_id) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      890132759
                    ),
                    model: {
                      value: _vm.active_org,
                      callback: function ($$v) {
                        _vm.active_org = $$v
                      },
                      expression: "active_org",
                    },
                  },
                  [
                    _c("template", { slot: "no-options" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__t("CHOICE_ORG")) +
                          "\n                        "
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-address-book fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }